import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubCategoryListComponent } from './sub-category-list.component';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { SubCategoryChildItemsComponent } from './sub-category-child-items/sub-category-child-items.component';

@NgModule({
  declarations: [
    SubCategoryListComponent,
    SubCategoryChildItemsComponent,
    
    
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatMenuModule,
    MatExpansionModule

  ],exports:[
    SubCategoryListComponent
  ]
})
export class SubCategoryListModule { }
